import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-data-extraction',
  templateUrl: './data-extraction.component.html',
  styleUrls: ['./data-extraction.component.css']
})
export class DataExtractionComponent implements OnInit {

  title: string = "Land Acquisition PDF Data Extraction";

  // File selection state
  selectedFiles: any = null;

  // Drag & drop and UI state
  isDragging: boolean = false;
  showRawOcr: boolean = false;

  // Extraction results and review record
  pdfExtractionResult: any = null;
  showExtractionReview: boolean = false;
  reviewRecord: any = null;

  // Dropdown data for Layout & Village context
  layoutlist: any[] = [];
  villagelist: any[] = [];
  layoutDetails: any = null;
  selectedLayoutId: any = null;
  selectedVillageId: any = null;
  i: any = {
    LayoutId: null,
    Village: null
  };

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandler
  ) { }

  ngOnInit(): void {
    this.GetAlllayouts();

    // Check if layoutId and villageId were passed via query parameters
    this.route.queryParams.subscribe(params => {
      if (params['layoutId']) {
        this.selectedLayoutId = +params['layoutId'];
        this.i.LayoutId = +params['layoutId'];
        this.GetVillagesByLayoutId(this.selectedLayoutId);
      }
      if (params['villageId']) {
        this.selectedVillageId = +params['villageId'];
        this.i.Village = +params['villageId'];
      }
      if (this.selectedLayoutId && this.selectedVillageId) {
        this.Getlayoutdetailsbyid(this.selectedLayoutId, this.selectedVillageId);
      }
    });
  }

  // ===================== LAYOUT & VILLAGE METHODS =====================

  GetAlllayouts(): void {
    const spinner = document.getElementById('loader-spinner');
    if (spinner) { spinner.style.display = "block"; }

    this.userService.Getalllayouts().subscribe({
      next: (response: any) => {
        this.layoutlist = response || [];
        if (spinner) { spinner.style.display = "none"; }
      },
      error: (error: any) => {
        if (spinner) { spinner.style.display = "none"; }
        this.errorHandler.handleError(error);
      }
    });
  }

  GetVillagesByLayoutId(layoutId: number): void {
    if (!layoutId) {
      this.villagelist = [];
      this.layoutDetails = null;
      return;
    }

    const spinner = document.getElementById('loader-spinner');
    if (spinner) { spinner.style.display = "block"; }

    this.userService.GetAllvillagesbylayoutid(layoutId).subscribe({
      next: (response: any) => {
        this.villagelist = response || [];
        if (spinner) { spinner.style.display = "none"; }
      },
      error: (error: any) => {
        if (spinner) { spinner.style.display = "none"; }
        this.errorHandler.handleError(error);
      }
    });
  }

  Getlayoutdetailsbyid(layoutId: number, villageId: number): void {
    if (!layoutId || !villageId) { return; }
    const spinner = document.getElementById('loader-spinner');
    if (spinner) { spinner.style.display = "block"; }

    this.userService.Getlayoutdetailsbyid(layoutId, villageId).subscribe({
      next: (response: any) => {
        if (spinner) { spinner.style.display = "none"; }
        this.layoutDetails = response;
      },
      error: (error: any) => {
        if (spinner) { spinner.style.display = "none"; }
        this.errorHandler.handleError(error);
      }
    });
  }

  // ===================== FILE EXTRACTION =====================

  triggerFileInput(): void {
    const fileInput = document.getElementById('pdfFileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onFilesSelected(event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFiles = event.target.files;
    } else {
      this.selectedFiles = null;
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0];
      if (droppedFile.type === 'application/pdf' || droppedFile.name.toLowerCase().endsWith('.pdf')) {
        this.selectedFiles = event.dataTransfer.files;
      } else {
        swal("Warning!", "Only PDF files can be run through extraction.", "warning");
      }
    }
  }

  clearSelectedFile(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.selectedFiles = null;
    const fileInput = document.getElementById('pdfFileInput') as HTMLInputElement;
    if (fileInput) { fileInput.value = ''; }
  }

  getSelectedFileName(): string {
    return this.selectedFiles && this.selectedFiles.length > 0 ? this.selectedFiles[0].name : '';
  }

  getSelectedFileSize(): string {
    if (!this.selectedFiles || this.selectedFiles.length === 0) { return ''; }
    const bytes = this.selectedFiles[0].size;
    if (bytes === 0) { return '0 Bytes'; }
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  toggleRawOcr(): void {
    this.showRawOcr = !this.showRawOcr;
  }

  onUploadFiles(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      swal("Warning!", "Please select a scanned PDF to extract.", "warning");
      return;
    }

    const file = this.selectedFiles[0];
    if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
      swal("Warning!", "Only PDF files can be run through extraction.", "warning");
      return;
    }

    const formData = new FormData();
    formData.append('file', file, file.name);

    // Show loader + "please wait" message
    this.showExtractionLoader();

    this.userService.extractCandidatesFromPdf(formData).subscribe({
      next: (response: any) => {

        // Hide loader + message
        this.hideExtractionLoader();

        this.pdfExtractionResult = response;

        const suggested = response.SuggestedData || {};
        const suggestedVillage = suggested.Village || {};

        // Prefer whatever Layout/Village is already selected in the main grid —
        // that's a verified DB record, more trustworthy than an OCR guess.
        // Fall back to the OCR-guessed value only when nothing is selected.
        const layoutId = (this.i && this.i.LayoutId) || this.selectedLayoutId;
        const villageId = (this.i && this.i.Village) || this.selectedVillageId;
        const matchedLayout = this.layoutlist ? this.layoutlist.find((l: any) => l.LayoutId === layoutId) : null;
        const matchedVillage = this.villagelist ? this.villagelist.find((v: any) => v.VillageId === villageId) : null;

        this.reviewRecord = {
          LayoutName: (matchedLayout && matchedLayout.LayoutName) || suggested.LayoutName || '',
          PreliminaryNotificationNo: (this.layoutDetails && this.layoutDetails.PreliminaryNotificationNo) || suggested.PreliminaryNotificationNo || '',
          PreliminaryNotificationDate: (this.layoutDetails && this.layoutDetails.PreliminaryNotificationDate) || suggested.PreliminaryNotificationDate || '',
          FinalNotificationNo: (this.layoutDetails && this.layoutDetails.FinalNotificationNo) || suggested.FinalNotificationNo || '',
          FinalNotificationDate: (this.layoutDetails && this.layoutDetails.FinalNotificationDate) || suggested.FinalNotificationDate || '',
          Village: {
            VillageName: (matchedVillage && matchedVillage.VillageName) || suggestedVillage.VillageName || '',
            Hobli: (matchedVillage && matchedVillage.Hobli) || (this.layoutDetails && this.layoutDetails.Hobli) || suggestedVillage.Hobli || '',
            Taluk: (matchedVillage && matchedVillage.Taluk) || (this.layoutDetails && this.layoutDetails.Taluk) || suggestedVillage.Taluk || ''
          },
          LandDetails: (suggested.LandDetails && suggested.LandDetails.length > 0)
            ? suggested.LandDetails.map((d: any) => this.normalizeLandDetail(d))
            : [this.blankLandDetailRow()]
        };

        this.showExtractionReview = true;
        this.showRawOcr = false;

        this.clearSelectedFile();
      },

      error: (error: any) => {

        // Hide loader + message (also on failure, otherwise it stays on screen)
        this.hideExtractionLoader();

        this.errorHandler.handleError(error);
      }
    });
  }

  // ---------------------------------------------------------------------
  // Loader + "please wait" message helpers
  // ---------------------------------------------------------------------
  private showExtractionLoader(): void {
    const spinner = document.getElementById('loader-spinner');
    if (spinner) { spinner.style.display = "block"; }

    // Non-dismissable message (no button, cannot be closed by clicking outside / Esc)
    swal({
      title: "Extracting Data",
      text: "Data is being extracted from the PDF. Please wait...",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  }

  private hideExtractionLoader(): void {
    const spinner = document.getElementById('loader-spinner');
    if (spinner) { spinner.style.display = "none"; }

    (swal as any).close();
  }

  normalizeLandDetail(d: any): any {
    return { ...this.blankLandDetailRow(), ...d };
  }

  blankLandDetailRow(): any {
    return {
      Khathedars: '',
      SurveyNo: '',
      Hissa: '',
      RTCExtent: '',
      NotificationExtent: '',
      KharabExtent: '',
      AwardPassedExtent: '',
      Notice12_2_Date: '',
      Notice16_2_Date: '',
      TahsildarPayment: '',
      KharabChequeNo: '',
      KhathedarAmount: '',
      KhathedarChequeNo: '',
      KhathedarExtent: '',
      KhathedarNotifiedExtent_AG: '',
      KhathedarSqftDevelSite: '',
      CourtAmount: '',
      CourtChequeNo: '',
      CourtExtent: '',
      Denotification: '',
      Remarks: ''
    };
  }

  addLandDetailRow(): void {
    if (!this.reviewRecord) { return; }
    if (!this.reviewRecord.LandDetails) {
      this.reviewRecord.LandDetails = [];
    }
    this.reviewRecord.LandDetails.push(this.blankLandDetailRow());
  }

  removeLandDetailRow(index: number): void {
    if (this.reviewRecord && this.reviewRecord.LandDetails && this.reviewRecord.LandDetails.length > 1) {
      this.reviewRecord.LandDetails.splice(index, 1);
    }
  }

  closeExtractionReview(): void {
    this.showExtractionReview = false;
    this.pdfExtractionResult = null;
    this.reviewRecord = null;
    this.showRawOcr = false;
  }

  onConfirmIngest(): void {
    if (!this.reviewRecord || !this.reviewRecord.LayoutName || !this.reviewRecord.Village || !this.reviewRecord.Village.VillageName) {
      swal("Warning!", "Layout Name and Village Name are required.", "warning");
      return;
    }
    const hasSurveyNo = this.reviewRecord.LandDetails && this.reviewRecord.LandDetails.some((d: any) => d.SurveyNo && d.SurveyNo.trim() !== '');
    if (!hasSurveyNo) {
      swal("Warning!", "Enter at least one Survey No. before confirming.", "warning");
      return;
    }

    const spinner = document.getElementById('loader-spinner');
    if (spinner) { spinner.style.display = "block"; }

    this.userService.confirmLandAcquisitionRecord(this.reviewRecord).subscribe({
      next: (response: any) => {
        if (spinner) { spinner.style.display = "none"; }
        swal("Success!", response.Message || "Land acquisition record saved.", "success");
        this.closeExtractionReview();
        if (this.i && this.i.LayoutId && this.i.Village) {
          this.Getlayoutdetailsbyid(this.i.LayoutId, this.i.Village);
        }
      },
      error: (error: any) => {
        if (spinner) { spinner.style.display = "none"; }
        this.errorHandler.handleError(error);
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/home/layoutplan']);
  }
}



// WEBPACK FOOTER //
// ./src/app/bda/data-extraction/data-extraction.component.ts